/* eslint-disable react/prop-types */
import React from 'react';
import ReactPlayer from 'react-player';
import analytics from '../../../utils/analytics/analytics';

interface ReactPlayerVideoProps {
    url: string;
    title: string;
    onError?: (error: unknown) => void;
}

const trackVideoEvent = (params: {
    name: string;
    event: string;
    action: string;
    label: string;
}) => {
    const { name, event, action, label } = params;
    analytics.trackEvent(name, {
        event,
        eventComponent: 'video',
        category: 'video',
        action,
        label
    });
};

const handleOnError = () => {
    trackVideoEvent({
        name: 'videoPlayerError',
        event: 'video_error',
        action: 'error',
        label: 'Video player error'
    });
};

const handleOnStart = () => {
    trackVideoEvent({
        name: 'videoPlayerStart',
        event: 'video_started',
        action: 'start',
        label: 'Video player start'
    });
};

const handleOnEnded = () => {
    trackVideoEvent({
        name: 'videoPlayerEnd',
        event: 'video_ended',
        action: 'end',
        label: 'Video player end'
    });
};

const ReactPlayerVideo: React.FC<ReactPlayerVideoProps> = ({
    url,
    title,
    onError
}) => {
    const [isLoading, setIsLoading] = React.useState(true);

    return (
        <div className="component-video__container" aria-label={title}>
            <ReactPlayer
                className="component-video__iframe"
                title={title}
                url={url}
                width="100%"
                height="100%"
                controls={true}
                onReady={() => setIsLoading(false)}
                onError={(error) => {
                    handleOnError();
                    onError?.(error);
                }}
                onStart={handleOnStart}
                onEnded={handleOnEnded}
                style={{ display: isLoading ? 'none' : 'block' }}
            />
        </div>
    );
};

export default ReactPlayerVideo;
